const FUSO_BRASILIA = "America/Sao_Paulo";

export function formatarDataBrasilia(isoDate: string): string {
  if (!isoDate) return "—";

  const data = new Date(isoDate);
  if (Number.isNaN(data.getTime())) return "—";

  const dataFormatada = data.toLocaleDateString("pt-BR", { timeZone: FUSO_BRASILIA });
  const horaFormatada = data.toLocaleTimeString("pt-BR", {
    timeZone: FUSO_BRASILIA,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return `${dataFormatada} ${horaFormatada}`;
}
